<template>
  <div>
    <icon-view
      gradient
      class="mr-2 mt-3 mb-4 rounded-circle icon-view-color-text"
      icon="fas fa-info-circle color-orange mb-1"
      title="Información General"
      icon-background="white"
      icon-color="#FF7058"
      icon-size="16px"
    />
    <div class="row">
      <div
        class="col-12"
        :class="{
          'col-md-2': isWorkshop,
          'col-md-3': isMessage,
          'col-md-6': isEducationalMaterial,
          'col-md-4': !isWorkshop && !isMessage && !isEducationalMaterial,
        }"
      >
        <span class="data-title d-block mb-2">
          Portal:
        </span>
        <validation-provider v-slot="{ errors }" name="portal" rules="required">
          <custom-drop-down
            v-model="model.portal"
            id="portal"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            custom-error-msg="El portal es requerido."
            :error="errors[0]"
            :options="portals"
            :disabled="readOnly"
            @input="getModules"
          />
        </validation-provider>
      </div>
      <div class="col-2" v-if="isWorkshop">
        <span class="data-title d-block mb-2">
          Metodología del Taller:
        </span>
        <validation-provider v-slot="{ errors }" name="portal" rules="required">
          <custom-drop-down
            v-model="model.methodology"
            id="methodologyId"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            custom-error-msg="El campo es requerido."
            :error="errors[0]"
            :options="workshopMethodologies"
            :disabled="readOnly"
          />
        </validation-provider>
      </div>
      <div
        v-if="isTeachingMaterial"
        class="col-12"
        :class="{ 'col-md-4': !isMessage, 'col-md-3': isMessage }"
      >
        <span class="data-title d-block mb-2">
          Módulo:
        </span>
        <validation-provider v-slot="{ errors }" name="module" rules="required">
          <custom-drop-down
            v-model="model.module"
            id="module"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            custom-error-msg="El módulo es requerido."
            :error="errors[0]"
            :options="modules"
            :disabled="readOnly"
            @input="getLinks"
          />
        </validation-provider>
      </div>
      <div
        v-if="isTeachingMaterial"
        class="col-12"
        :class="{ 'col-md-4': !isMessage, 'col-md-3': isMessage }"
      >
        <span class="data-title d-block mb-2">
          Tarjeta:
        </span>
        <validation-provider v-slot="{ errors }" name="card" rules="required">
          <custom-drop-down
            v-model="model.card"
            id="card"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            custom-error-msg="El tarjeta es requerido."
            :error="errors[0]"
            :options="links"
            :disabled="readOnly"
          />
        </validation-provider>
      </div>
      <div
        v-if="isEducationalMaterial"
        class="col-12"
        :class="{
          'col-md-4': !isMessage && !isEducationalMaterial,
          'col-md-3': isMessage,
          'col-md-6': isEducationalMaterial,
        }"
      >
        <span class="data-title d-block mb-2">
          Categoría:
        </span>
        <validation-provider
          v-slot="{ errors }"
          name="category"
          rules="required"
        >
          <custom-drop-down
            v-model="model.educationalMaterialCategory"
            id="educationalMaterialCategory"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            custom-error-msg="La categoría es requerida."
            :error="errors[0]"
            :options="educationalMaterialCategories"
            :disabled="readOnly"
          />
        </validation-provider>
      </div>
      <div
        v-if="!isTeachingMaterial && !isEducationalMaterial"
        class="col-12 "
        :class="{ 'col-md-2': !isMessage, 'col-md-3': isMessage }"
      >
        <span class="data-title d-block mb-2">
          Fecha de Comienzo:
        </span>
        <validation-provider
          v-slot="{ errors }"
          name="startDate"
          rules="required"
        >
          <custom-date-picker
            id="startDate"
            v-model="model.start.date"
            :class-container="'w-100'"
            custom-error-msg="La fecha de comienzo es requerido."
            :error="errors[0]"
            format="dd/MMM./yyyy"
            @input="onChangeTime"
            required
            :disabled="readOnly"
          />
        </validation-provider>
      </div>
      <div
        class="col-12 col-md-2"
        v-if="!isMessage && !isTeachingMaterial && !isEducationalMaterial"
      >
        <span class="color-gray-6 font-14 font-weight-normal">
          Hora de Comienzo:
        </span>
        <validation-observer ref="startHourForm" v-slot="{ errors }">
          <div class="row pl-3 mt-2 div-time">
            <div class="col px-0">
              <validation-provider
                name="hour"
                :rules="{
                  numeric: true,
                  required: (!isWorkshop || !isGraphic) && hasStartTime,
                }"
              >
                <custom-input
                  mask-type="Day"
                  v-model="model.start.hour"
                  class="calendar-available-space-input"
                  :class="{
                    'border border-danger rounded': errors.hour?.length,
                  }"
                  @input="onChangeTime"
                  :disabled="!model.start.date || readOnly"
                />
              </validation-provider>
            </div>
            <div class="col-0 px-1 pt-1">
              :
            </div>
            <div class="col px-0 mr-2">
              <validation-provider
                name="minute"
                :rules="{
                  numeric: true,
                  required: hasStartTime,
                }"
              >
                <custom-input
                  mask-type="Day"
                  v-model="model.start.minute"
                  class="calendar-available-space-input"
                  :class="{
                    'border border-danger rounded': errors.minute?.length,
                  }"
                  :disabled="!model.start.date || readOnly"
                  @input="onChangeTime"
                />
              </validation-provider>
            </div>
            <div class="px-0 calendar-available-space-select">
              <validation-provider
                name="type"
                :rules="{
                  required: hasStartTime,
                }"
              >
                <select
                  id="start"
                  v-model="model.start.type"
                  class="form-control"
                  :disabled="!model.start.date || readOnly"
                  :class="{
                    'border border-danger rounded': errors.type?.length,
                  }"
                  @change="onChangeTime"
                >
                  <option :value="null"></option>
                  <option value="AM">AM</option>
                  <option value="PM">PM</option>
                </select>
              </validation-provider>
            </div>
          </div>
          <div class="row py-0 my-0">
            <div
              v-for="(error, key) in errors"
              :key="key"
              class="col-12 py-0 my-0 text-danger"
            >
              <span v-if="error[0] === 'Campo Requerido'">
                El campo {{ parseErrorMessage(key) }} es requerido.
              </span>
              <span v-else>{{ parseErrorMessage(error[0]) }}</span>
            </div>
          </div>
        </validation-observer>
      </div>
      <div
        v-if="!isTeachingMaterial && !isEducationalMaterial"
        class="col-12"
        :class="{ 'col-md-2': !isMessage, 'col-md-3': isMessage }"
      >
        <span class="data-title d-block mb-2">
          Fecha de Finalización:
        </span>
        <validation-provider
          v-slot="{ errors }"
          name="endDate"
          rules="required"
        >
          <custom-date-picker
            id="endDate"
            v-model="model.end.date"
            :class-container="'w-100'"
            :class="{
              'border border-danger rounded':
                isStartGreaterThanEnd && validated,
            }"
            custom-error-msg="La fecha de finalización es requerido."
            :error="errors[0]"
            format="dd/MMM./yyyy"
            required
            :disabled="readOnly"
            @input="resetInput"
          />
        </validation-provider>
        <div class="row py-0 my-0">
          <div
            v-if="validated && isStartGreaterThanEnd"
            class="col-12 py-0 my-0 text-danger"
          >
            <span>
              La fecha de finalización no puede ser menor a la fecha de
              comienzo.
            </span>
          </div>
        </div>
      </div>
      <div
        class="col-12 col-md-2"
        v-if="!isMessage && !isTeachingMaterial && !isEducationalMaterial"
      >
        <span class="color-gray-6 font-14 font-weight-normal">
          Hora de Finalización:
        </span>
        <validation-observer ref="endHourForm" v-slot="{ errors }">
          <div class="row pl-3 mt-2 div-time mr-0">
            <div class="col px-0">
              <validation-provider
                name="hour"
                :rules="{
                  numeric: true,
                  required: (!isWorkshop || !isGraphic) && hasEndTime,
                }"
              >
                <custom-input
                  mask-type="Day"
                  v-model="model.end.hour"
                  class="calendar-available-space-input"
                  :class="{
                    'border border-danger rounded':
                      errors.hour?.length &&
                      ((isStartGreaterThanEnd && validated) ||
                        (isStartEqualToEnd && validated)),
                  }"
                  :disabled="!model.end.date || readOnly"
                  @input="onChangeTime"
                />
              </validation-provider>
            </div>
            <div class="col-0 px-1 pt-1">
              :
            </div>
            <div class="col px-0 mr-2">
              <validation-provider
                name="minute"
                :rules="{
                  numeric: true,
                  required: hasEndTime,
                }"
              >
                <custom-input
                  mask-type="Day"
                  v-model="model.end.minute"
                  class="calendar-available-space-input"
                  :class="{
                    'border border-danger rounded':
                      errors.minute?.length &&
                      ((isStartGreaterThanEnd && validated) ||
                        (isStartEqualToEnd && validated)),
                  }"
                  :disabled="!model.end.date || readOnly"
                  @input="onChangeTime"
                />
              </validation-provider>
            </div>
            <div class="px-0 calendar-available-space-select">
              <validation-provider
                name="type"
                :rules="{
                  required: hasEndTime,
                }"
              >
                <select
                  id="end"
                  v-model="model.end.type"
                  class="form-control"
                  :class="{
                    'border border-danger rounded':
                      errors.type?.length &&
                      ((isStartGreaterThanEnd && validated) ||
                        (isStartEqualToEnd && validated)),
                  }"
                  :required="hasEndTime"
                  :disabled="!model.end.date || readOnly"
                  @change="onChangeTime"
                >
                  <option :value="null"></option>
                  <option value="AM">AM</option>
                  <option value="PM">PM</option>
                </select>
              </validation-provider>
            </div>
          </div>
          <div class="row py-0 my-0">
            <div
              v-for="(error, key) in errors"
              :key="key"
              class="col-12 py-0 my-0 text-danger"
            >
              <span v-if="error[0] === 'Campo Requerido'">
                El campo {{ parseErrorMessage(key) }} es requerido.
              </span>
              <span v-else>{{ parseErrorMessage(error[0]) }}</span>
            </div>
            <div
              v-if="
                model.end.date &&
                  model.end.hour &&
                  validated &&
                  isStartGreaterThanEnd
              "
              class="col-12 py-0 my-0 text-danger"
            >
              <span>
                La hora de finalización no puede ser menor a la hora de
                comienzo.
              </span>
            </div>
            <div
              v-if="
                model.end.date &&
                  model.end.hour &&
                  validated &&
                  isStartEqualToEnd
              "
              class="col-12 py-0 my-0 text-danger"
            >
              <span>
                La hora de finalización no puede ser igual a la hora de
                comienzo.
              </span>
            </div>
          </div>
        </validation-observer>
      </div>
      <div class="col-12 col-md-3" v-if="isMessage">
        <span class="data-title d-block mb-2">
          Ubicación del Mensaje:
        </span>
        <validation-provider
          v-slot="{ errors }"
          name="messageLocation"
          rules="required"
        >
          <custom-drop-down
            v-model="model.messageLocation"
            id="messageLocation"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione"
            custom-error-msg="La ubicación del mensaje es requerida."
            :error="errors[0]"
            :options="messageLocations"
            :disabled="readOnly"
          />
        </validation-provider>
      </div>
      <div class="col-12 col-md-4" v-if="isMessage && isParentPortal">
        <span class="data-title d-block mb-2">
          &nbsp;
        </span>
        <custom-checkbox
          text="¿Desea enviar Notificación Push (EeMóvil)?"
          v-model="model.sendMobilePushNotification"
          :disabled="readOnly"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <span class="data-title d-block mb-2">
          Título:
        </span>
        <validation-provider v-slot="{ errors }" name="title" rules="required">
          <custom-input
            :value="model.title"
            @input="(val) => (model.title = val || null)"
            id="title"
            maxlength="500"
            :error="errors[0]"
            custom-error-msg="El título es requerido."
            :disabled="readOnly"
          />
        </validation-provider>
      </div>
    </div>

    <div
      class="row mt-3"
      v-if="isMessage && !isTeachingMaterial && !isEducationalMaterial"
    >
      <div class="col-12">
        <span class="data-title d-block mb-2">
          Mensaje Corto:
        </span>
        <validation-provider
          v-slot="{ errors }"
          name="shortDescription"
          rules="required"
        >
          <custom-input
            :value="model.shortDescription"
            @input="(val) => (model.shortDescription = val || null)"
            id="title"
            maxlength="500"
            :error="errors[0]"
            custom-error-msg="El mensaje corto es requerido."
            :disabled="readOnly"
          />
        </validation-provider>
      </div>
    </div>

    <div
      class="row mt-3"
      v-if="
        isEvents ||
          isWorkshop ||
          isTeachingMaterial ||
          ((isNews || isWorkshop) && isPublicPortal)
      "
    >
      <div class="col-12">
        <span class="data-title d-block mb-2">
          Resúmen:
        </span>
        <validation-provider v-slot="{ errors }" name="shortDescription">
          <custom-text-area
            id="input-resumen"
            :value="model.shortDescription"
            @input="(val) => (model.shortDescription = val || null)"
            class="textarea__extended"
            :count-classes="['float-right']"
            custom-error-msg="El resumen es requerido."
            :error="errors[0]"
            :maxlength="500"
            show-char-count
            :disabled="readOnly"
          />
        </validation-provider>
      </div>
    </div>

    <div class="row mt-3" v-if="isMessage">
      <div class="col-12">
        <validation-provider
          v-slot="{ errors }"
          :rules="{
            regex: urlRegexRule,
          }"
        >
          <custom-input
            id="input-registry-url"
            label="Insertar URL para publicar con el mensaje:"
            maxlength="150"
            v-model="model.url"
            :error="errors[0]"
            custom-error-msg="La URL no es válida."
            :disabled="readOnly"
          ></custom-input>
        </validation-provider>
      </div>
    </div>

    <div
      class="row mt-3"
      v-if="
        isEvents ||
          isMessage ||
          (isNews && isPublicPortal) ||
          (isWorkshop && isPublicPortal)
      "
    >
      <div class="col-12">
        <span class="data-title d-block mb-2">
          Descripción / Contenido:
        </span>
        <ValidationProvider v-slot="{ errors }" rules="required">
          <vue-editor
            id="description-input"
            v-model="model.description"
            :disabled="readOnly"
          />
          <error
            v-if="errors[0]"
            message="La descripción/contenido es requerido."
            variant="no-border"
          />
        </ValidationProvider>
      </div>
    </div>

    <div
      class="row mt-3"
      v-if="isEvents || isWorkshop || isEducationalMaterial"
    >
      <div class="col-12">
        <validation-provider
          v-slot="{ errors }"
          :rules="{
            regex: urlRegexRule,
            required: !isWorkshop && !isEvents,
          }"
        >
          <custom-input
            id="input-registry-url"
            :label="
              isWorkshop
                ? 'Insertar URL para acceder al taller (debe comenzar con https://):'
                : isEducationalMaterial
                ? 'Insertar URL para publicar:'
                : 'Insertar URL para publicar el enlace para el registro en línea (debe comenzar con https://):'
            "
            maxlength="150"
            v-model="model.url"
            :error="errors[0]"
            custom-error-msg="La URL no es válida."
            :disabled="readOnly"
          ></custom-input>
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import IconView from 'icon-view';
import CustomInput from 'CustomInput';
import CustomTextArea from 'CustomTextArea';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import CustomDropDown from 'custom-drop-down';
import CustomCheckbox from 'CheckBox';
import Error from '@/components/common/Error';
import { VueEditor } from 'vue2-editor';
import moment from 'moment';
import TYPES from '@/utils/constants/operations-dashboard-management/scheduleItemTypes';
import operationMessage from '@/modules/operation-message/api.js';
import {
  getApplications as _getApplications,
  getModules as _getModules,
  getLinks as _getLinks,
} from '@/modules/common/code.api.js';
import APPS from '@/utils/constants/applications.js';
import { cardsbymodule as _cardsByModule } from '@/services/operations/dashboard-management';

const URL_REGEX = /^(https):\/\/[^\s$.?#].[^\s]*$/;
const format = 'h:mm A';
import {
  getEducationalMaterialCategories,
  getWorkshopMethodologyTypes,
} from '@/services/operations/dashboard-management';
export default {
  name: 'InformationToPublish',
  components: {
    IconView,
    CustomInput,
    CustomTextArea,
    CustomDatePicker,
    CustomDropDown,
    CustomCheckbox,
    Error,
    VueEditor,
  },
  data() {
    return {
      portals: [],
      modules: [],
      links: [],
      educationalMaterialCategories: [],
      workshopMethodologies: [],
      messageLocations: [],
      validated: false,
      urlRegexRule: URL_REGEX,
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    type: {
      type: Number,
      default: () => 0,
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isEvents() {
      return this.type === TYPES.Event;
    },
    isWorkshop() {
      return this.type === TYPES.Workshop;
    },
    isMessage() {
      return this.type === TYPES.Message;
    },
    isGraphic() {
      return this.type === TYPES.Graphic;
    },
    isTeachingMaterial() {
      return this.type === TYPES.TeachingMaterial;
    },
    isNews() {
      return this.type === TYPES.News;
    },
    isEducationalMaterial() {
      return this.type === TYPES.EducationalMaterial;
    },
    isPublicPortal() {
      const { id } = this.model.portal ?? {};
      return id === APPS.PublicPortal.toLowerCase();
    },
    isParentPortal() {
      const { id } = this.model.portal ?? {};
      return id === APPS.Parent.toLowerCase();
    },
    hasStartTime() {
      return (
        !!this.model.start.hour ||
        !!this.model.start.minute ||
        !!this.model.start.type
      );
    },
    hasEndTime() {
      return (
        !!this.model.end.hour ||
        !!this.model.end.minute ||
        !!this.model.end.type
      );
    },
    startHourValue() {
      const { hour, minute, type } = this.model.start;
      const date = moment(this.model.start.date);
      const time = `${hour}:${minute} ${type}`;
      const start = moment(time, format);
      date
        .set({
          hour: start.get('hour'),
          minute: start.get('minute'),
          second: start.get('second'),
        })
        .format();

      return date;
    },
    endHourValue() {
      const { hour, minute, type } = this.model.end;
      const date = moment(this.model.end.date);
      const time = `${hour}:${minute} ${type}`;
      const end = moment(time, format);

      date
        .set({
          hour: end.get('hour'),
          minute: end.get('minute'),
          second: end.get('second'),
        })
        .format();

      return date;
    },
    isStartGreaterThanEnd() {
      return !this.hasStartTime && !this.hasEndTime
        ? moment(this.model.start.date).isAfter(moment(this.model.end.date))
        : this.startHourValue.isAfter(this.endHourValue);
    },
    isStartEqualToEnd() {
      return this.startHourValue.format() === this.endHourValue.format();
    },
  },
  async mounted() {
    await this.getPortals();
    await this.getMessageLocation();
    await this.getEducationalMaterialCategories();
    await this.getWorkshopMethodologyTypes();
  },
  methods: {
    async getEducationalMaterialCategories() {
      const { data } = await getEducationalMaterialCategories();
      this.educationalMaterialCategories = data;
    },
    async getWorkshopMethodologyTypes() {
      const { data } = await getWorkshopMethodologyTypes();
      this.workshopMethodologies = data;
    },
    async getModules(reset = true) {
      if (reset) {
        this.model = {
          ...this.model,
          card: null,
          module: null,
        };
        this.modules = [];
        this.links = [];
      }
      let application = this.model.portal;
      if (!application) return;

      const { data } = await _getModules(application.id);
      this.modules = [...data];
    },
    async getLinks(reset = true) {
      if (reset) {
        this.model.card = null;
        this.links = [];
      }

      const module = this.model.module;
      if (!module) return;

      const applicationId = this.model?.portal?.id ?? null;

      const { data } = await _cardsByModule(module.id, applicationId);
      this.links = [...data];
    },
    parseErrorMessage(msg) {
      if (!msg) return '';
      return msg
        .replace('hour', 'hora')
        .replace('minute', 'minuto')
        .replace('type', 'horario');
    },
    async getPortals() {
      const { data } = await _getApplications();
      this.portals = data?.map((x) => ({ ...x, id: x.keyId })) ?? [];
    },
    async getMessageLocation() {
      const { data } = await operationMessage.fetchLocation();
      this.messageLocations = data ?? [];
    },
    resetInput() {
      this.onChangeTime();
      this.$emit('date-changed');
    },
    async onChangeTime() {
      if (!this.hasStartTime && !this.hasEndTime) {
        this.validated = true;
        return !this.isStartGreaterThanEnd;
      }

      const isValidStart = await this.$refs.startHourForm.validate();
      const isValidEnd = await this.$refs.endHourForm.validate();
      this.validated = isValidStart && isValidEnd;
      if (
        !this.validated ||
        this.isStartGreaterThanEnd ||
        this.isStartEqualToEnd
      ) {
        return false;
      }

      return true;
    },
    async validate() {
      if (
        !this.isMessage &&
        !this.isTeachingMaterial &&
        !this.isEducationalMaterial
      )
        return this.onChangeTime();
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.textarea__extended ::v-deep {
  .position-relative {
    i {
      display: none;
    }
  }
}

.div-time {
  margin-top: 12px !important;
}
</style>
